module.exports = __webpack_public_path__ + "img/home_bnews7_1.49499826.jpeg";